import { useEffect, useState, useContext } from 'react'
import Layout from "../../components/layout"
import { HeaderWrapper, ContentWrapper } from './style'
import Pagination from '../../components/pagination';
import { getAdminUsersApi, deleteAdminUserApi } from '../../api'
import { AuthContext } from '../../context/auth';
import moment from 'moment/moment';
import DeleteAdminModal from "../../components/modals/DeleteAdminModal"
import AddAdminModal from "../../components/modals/addAdminModal"
import ChangePasswordModal from "../../components/modals/ChangePasswordModal"
import ChangeRoleModal from "../../components/modals/ChangeRoleModal"

const Index = () => {
  const { setIsLoading, setNotification, user } = useContext(AuthContext)
  const [adminData, setAdminData] = useState([])
  const [currentPage, setCurrentPage] = useState(0);
  const [deleteAdminModal, setDeleteAdminModal] = useState(false)
  const [openAdminModal, setOpenAdminModal] = useState(false)
  const [changePasswordModal, setChangePasswordModal] = useState(false)
  const [changeRoleModal, setChangeRoleModal] = useState(false)
  const [selectedAdmin, setSelectedAdmin] = useState(null)
  const [token, setToken] = useState(null)

  const fetchAdmins = () => {
    setIsLoading(true)
    getAdminUsersApi(10, currentPage * 10).then(res => {
      if (res && res.data) {
        setAdminData(res?.data)
        setIsLoading(false)
      }
    }).catch(err => {
      console.error(err)
      setIsLoading(false)
    })
  }

  useEffect(() => {
    fetchAdmins()
  }, [currentPage])


  const onDeleteAdmin = () => {
    setIsLoading(true)
    deleteAdminUserApi(selectedAdmin?.id).then(res => {
      if (res && res.data) {
        fetchAdmins()
        setDeleteAdminModal(false)
        setOpenAdminModal(false)
        setSelectedAdmin(null)
        setIsLoading(false)
        setNotification({ type: 'success', message: 'Admin deleted successfully' })
      }
    }).catch(err => {
      setIsLoading(false)
      setNotification({ type: 'error', message: 'Something went wrong' })
    })
  }

  return (
    <Layout>
      <HeaderWrapper>
        <div className="header-title"><span className='sub-title'>Admins</span>{adminData?.count}</div>
        <div className="header-search-container">
          <button className='btn' onClick={() => setOpenAdminModal(true)}>Add Admin</button>
        </div>
      </HeaderWrapper>
      <ContentWrapper>
        {adminData && adminData?.count > 0 ? <>
          <table className={"mainTable"}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Created At</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {adminData?.users?.map((data) => {
                return (
                  <tr
                    key={data?.id}
                  >
                    <td>
                      {data?.first_name ? data?.first_name + " " + data?.last_name : "Admin User"}
                    </td>
                    <td>
                      {data?.email ? data?.email : "-"}
                    </td>
                    <td>
                      {data?.teamRole?.name ?? "Super Admin"}
                    </td>
                    <td>
                      {data?.created_at ? moment(data?.created_at).format('MMMM DD, YYYY, h:mm A') : "-"}
                    </td>
                    <td style={{ cursor: "pointer" }}>
                      <span style={{ display: 'flex', gap: '30px', alignItems: 'center', justifyContent: 'flex-end' }}>
                        <button className='role-btn' onClick={() => {
                          setSelectedAdmin(data)
                          setChangeRoleModal(true)
                        }}>Change Role</button>
                        <button style={{ fontSize: '16px', color: '#6c6a73' }} onClick={() => {
                          setSelectedAdmin(data)
                          setOpenAdminModal(true)
                        }}><i class="fal fa-pencil"></i></button>
                        <button style={{ fontSize: '16px', color: '#6c6a73' }}
                          disabled={user?.user?.id === data?.id}
                          onClick={() => {
                            setSelectedAdmin(data)
                            setDeleteAdminModal(true)
                          }}
                        ><i class="fal fa-trash-alt"></i></button>
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          {adminData?.count / adminData?.limit > 1 && <Pagination total={adminData?.count / adminData.limit} setCurrentPage={setCurrentPage} currentPage={currentPage} />}
        </>
          : <div className='no-orders'>
            <span className='icon'>
              <i class="far fa-boxes"></i>
            </span>
            <p>No admin users yet.</p>
          </div>
        }
      </ContentWrapper>
      {openAdminModal && <AddAdminModal setOpenAdminModal={setOpenAdminModal} selectedAdmin={selectedAdmin} setSelectedAdmin={setSelectedAdmin} fetchAdmins={fetchAdmins} setDeleteAdminModal={setDeleteAdminModal} setChangePasswordModal={setChangePasswordModal} setToken={setToken} />}
      {(deleteAdminModal && selectedAdmin) && <DeleteAdminModal selectedAdmin={selectedAdmin} setSelectedAdmin={setSelectedAdmin} setDeleteAdminModal={setDeleteAdminModal} onDeleteAdmin={onDeleteAdmin} />}
      {(changePasswordModal && selectedAdmin && token) && <ChangePasswordModal selectedAdmin={selectedAdmin} setChangePasswordModal={setChangePasswordModal} token={token} />}
      {(changeRoleModal && selectedAdmin) && <ChangeRoleModal selectedAdmin={selectedAdmin} setSelectedAdmin={setSelectedAdmin} setChangeRoleModal={setChangeRoleModal} fetchAdmins={fetchAdmins} />}
    </Layout>
  )
}

export default Index